
<template>
  <div class="w-full">
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page text-white">Learning Journals</div>
          <p class="text-left m-2 text-white">The Learning Journals are saved notes from your courses ..
            you can view and  update each note you took for a course on this page
          and also download to PDF format</p>
          <lms-button
                  color="#fff"
                  @click="downloadMasterJournal"
          >{{button.download_text}} </lms-button
          >

          <vue-html2pdf
                  :show-layout="false"
                  :enable-download="true"
                  :preview-modal="false"
                  filename="MasterJournal"
                  :pdf-quality="2"
                  :paginate-elements-by-height="2000"
                  :manual-pagination="false"
                  pdf-format="a4"
                  pdf-orientation="portrait"
                  pdf-content-width="100%"
                  ref="html2Pdf"
                  @hasGenerated="hasGenerated($event)"
                  :htmlToPdfOptions="htmlToPdfOptions"
          >
            <section slot="pdf-content">
              <!-- PDF Content Here -->
              <span class="flex justify-center mt-3 mb-3 "><img :src="landingLogo" width="100" height="100"></span>
              <h1 class="text-center bold mt-4 mb-4" style="text-transform: uppercase"><b> {{tenantCompany}}</b></h1>
              <h2 class="text-center bold mt-4 mb-4"><b> LEARNING JOURNAL MASTER PDF</b></h2>
              <div class="m-4 " style="font-size: 14px;!important;" v-html="masterNote"></div>
            </section>

          </vue-html2pdf>
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>
    <div class="">
      <div class="block sm:flex sm:justify-even sm:flex-wrap">
        <card v-for="note in notes" :key="note.id" :data="note" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueHtml2pdf from 'vue-html2pdf'

import FormActions from "@/mixins/FormActions";
import SettingsMixin from '@/mixins/SettingsMixin'
import note from "../../../components/general/note";
export default {
  mixins: [SettingsMixin,FormActions],
  components: {
    lcontainer: () => import("@/components/general/container"),
    card: () => import("@/components/learner/notesCard"),
    LmsButton: () => import("@/components/general/button"),
    VueHtml2pdf
  },
  data() {
    return {
      search: "",
      boards: [],
      notes: null,
      masterNote: '',
      button:{
        download_text: 'Download Master Journal',
      },
      htmlToPdfOptions: {
        margin: 0.5,

        filename: `MasterJournal.pdf`,

        image: {
          type: 'jpeg',
          quality: 0.98
        },

        enableLinks: false,

        html2canvas: {
          scale: 1,
          useCORS: true
        },
      }
    };
  },
  methods: {
    ...mapActions(["LearnerFetchJournals"]),
    downloadMasterJournal(){
      this.button.download_text = 'Downloading....'
      this.$refs.html2Pdf.generatePdf()
    },
    hasGenerated(){
      this.button.download_text = 'Download Master Journal'
    }
  },
  computed: {},
  async mounted() {
    let res = await this.LearnerFetchJournals();
    this.notes = res.data.data.journals;
    this.notes.forEach(note => {
      this.masterNote += "<p><br/><br/></p>"
      this.masterNote += `<h3 style="text-transform: uppercase;"><b>[ ${note.course.title} ] </b></h3>`
      this.masterNote += "<p><br/></p>"
      this.masterNote += note.note
      this.masterNote += "<p><br/></p>"

    })

  },
};
</script>
<style scoped></style>
